import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use lmc-dialog component instead.
 */
@Component({
    standalone: false,
    selector: 'common-dialog',
    templateUrl: 'common-dialog.html'
  })
  export class CommonDialog {
    readonly dialogRef = inject(MatDialogRef<CommonDialog>);
    readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  
    onDismiss(result: boolean): void {
      this.dialogRef.close(result);
    }
  }

  export interface DialogData {
    title: string;
    content: string;
  }